const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`313897e373a975173d1897fd25aaeba1dcb3f1e785aff03f229ced1b21bac0f5`, `313897e373a975173d1897fd25aaeba1dcb3f1e785aff03f229ced1b21bac0f5`, 1, 97), undefined, true, false, 1));
            }

            getTemplateName() {
                return `313897e373a975173d1897fd25aaeba1dcb3f1e785aff03f229ced1b21bac0f5`;
            }

            getSourceContext() {
                return new this.Source(``, `313897e373a975173d1897fd25aaeba1dcb3f1e785aff03f229ced1b21bac0f5`, ``);
            }
        }],
        [97, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/overview/overview.twig`, `313897e373a975173d1897fd25aaeba1dcb3f1e785aff03f229ced1b21bac0f5`, 1);

                this.blocks = new Map([
                    ['header', [this, 'block_header']],
                    ['actions', [this, 'block_actions']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/overview/overview.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_header(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    Header
  `);
            }

            block_actions(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    Actions
  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    Content
  `);
            }

            getTemplateName() {
                return `313897e373a975173d1897fd25aaeba1dcb3f1e785aff03f229ced1b21bac0f5`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `313897e373a975173d1897fd25aaeba1dcb3f1e785aff03f229ced1b21bac0f5`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '313897e373a975173d1897fd25aaeba1dcb3f1e785aff03f229ced1b21bac0f5');

let template = env.loadTemplate('313897e373a975173d1897fd25aaeba1dcb3f1e785aff03f229ced1b21bac0f5');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/overview/demo/basic.twig", args: context }
     );
     return rendered;;
};